<fieldset class="text-secondary my-3 w-full text-sm">
  <legend class="m-auto px-4">
    @if (pageSeparatorLabelTemplate()) {
      <ng-container
        [ngTemplateOutlet]="pageSeparatorLabelTemplate()"
        [ngTemplateOutletContext]="{ $implicit: document(), splitIndex: splitIndex() }" />
    }
  </legend>
</fieldset>
